import React, { useState } from 'react';
import { TextField, Button, Typography, Link } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CryptoJS from 'crypto-js'; // Import CryptoJS for SHA-256 hashing
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const apiUrl = 'http://wholesale.firehemp.com:5000';

// Create a custom theme with yellow primary and gray background
const customTheme = createTheme({
  palette: {
    primary: {
      main: '#FFD700',  // Yellow color for buttons, inputs, etc.
    },
    background: {
      default: '#3c3c3c',  // Gray background
    },
    text: {
      primary: '#FFD700',  // Yellow text color
    },
  },
  components: {
    MuiFilledInput: {
      input: {
        "&::placeholder": {
          color: "#FFD700"
        },
        color: "#FFD700", // if you also want to change the color of the input, this is the prop you'd use
      }
    },
    MuiInput: {
      input: {
        "&::placeholder": {
          color: "#FFD700"
        },
        color: "#FFD700", // if you also want to change the color of the input, this is the prop you'd use
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: '#FFD700', // Input text color
          '&::placeholder': {
            color: '#FFD700', // Placeholder color
            opacity: 1,       // Ensure opacity is not reduced
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFD700',  // Set initial border color to yellow
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFD700',  // Set border color on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFD700',  // Set border color on focus
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#FFD700', // Set the label color to yellow
          '&.Mui-focused': {
            color: '#FFD700', // Ensure it stays yellow when focused
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: '#fff',
          '&.Mui-selected': {
            backgroundColor: '#FFD700',
            color: '#000',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: 'black',
        },
      },
    },
  },
});

function Login({ onLogin, onSwitchToSignup, onSwitchToForgotPassword }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const navigate = useNavigate(); // Initialize useNavigate

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Hash the password using SHA-256
    const hashedPassword = CryptoJS.SHA256(password).toString();

    // Prepare payload
    const payload = { username, password: hashedPassword };

    try {
      const response = await fetch(`${apiUrl}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data.token) {
        // Store the token in localStorage (more secure and easier to manage)
        localStorage.setItem('token', data.token);

        toast.success('Login successful');
        onLogin(); // Call the onLogin function to handle login success

        // Redirect to the default "/" route after login
        navigate('/');
      } else {
        setError(true);
        setShowForgotPassword(true);
        toast.error(data.message || 'Invalid username or password');
      }
    } catch (err) {
      toast.error('An error occurred while logging in');
    }
  };

  return (
    <>
      <ThemeProvider theme={customTheme}>
        <ToastContainer />
        <form onSubmit={handleSubmit}>
          <img
            src="fh.png"
            style={{ width: '60%', height: '60%' }}
            alt="Logo"
          />
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
          />
          {error && showForgotPassword && (
            <Link component="button" onClick={onSwitchToForgotPassword} style={{ display: 'block', marginBottom: '10px' }}>
              Forgot password?
            </Link>
          )}
          <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: 'rgba(244,205,24,1)', color: 'black', fontWeight: 'bold', fontFamily: 'Montserrat, Arial, sans-serif' }}>
            Login
          </Button>
        </form>
      </ThemeProvider>
    </>
  );
}

export default Login;
